import React from 'react';

class Labels extends React.PureComponent {

  render() {
    this.labelList = [];

    if(this.props.labels) {

      if(typeof this.props.labels === 'object' && Object.keys(this.props.labels).length) {
        this.labelList = this.props.labels.map((item) =>
          <span className="brew-item__label" key={item.value}>{item.label}</span>
        );
      }
    }

    return (
      <>
        { this.labelList }
      </>
    )
  }
}

export default Labels;
